// src/hooks/useTyping.js
import { useRef, useCallback, useEffect } from 'react';

export const useTyping = (wsRef, currentChat) => {
    const typingTimeoutRef = useRef(null);
    const isTypingRef = useRef(false);
    const lastSentRef = useRef(0);
    const currentChatRef = useRef(currentChat);
    useEffect(() => {
        currentChatRef.current = currentChat;        
        // ✅ Сбрасываем состояние при смене чата
        isTypingRef.current = false;
        lastSentRef.current = 0;
        clearTimeout(typingTimeoutRef.current);
    }, [currentChat]);

    const sendTypingStatus = useCallback((isTyping) => {
         const chat = currentChatRef.current;
        if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) return;
        if (!chat) return;
        if (isTypingRef.current === isTyping) return;
        
        isTypingRef.current = isTyping;
        
        wsRef.current.send(JSON.stringify({
            type: 'typing',
            chat_id: chat.chat_id,
            is_typing: isTyping
        }));
    }, [wsRef]);

    const handleTyping = useCallback((value) => {
        if (value.trim().length > 0) {
            const now = Date.now();
            if (now - lastSentRef.current > 2000) {
                sendTypingStatus(true);
                lastSentRef.current = now;
            }
            
            clearTimeout(typingTimeoutRef.current);
            typingTimeoutRef.current = setTimeout(() => {
                sendTypingStatus(false);
            }, 2000);
        } else {
            sendTypingStatus(false);
        }
    }, [sendTypingStatus]);

    const resetTyping = useCallback(() => {
       isTypingRef.current = false;
        lastSentRef.current = 0;
        clearTimeout(typingTimeoutRef.current);

        const chat = currentChatRef.current;
        if (wsRef.current?.readyState === WebSocket.OPEN && chat) {
            wsRef.current.send(JSON.stringify({
                type: 'typing',
                chat_id: chat.chat_id,
                is_typing: false
            }));
        }
    }, [wsRef]);

    return { handleTyping, resetTyping };
};